import * as Types from '../../../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type CheckoutSuccessDataQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']
}>

export type CheckoutSuccessDataQuery = {
  customerDetails: { __typename: 'Customer'; id: string; email: string }
  order: {
    __typename: 'Order'
    id: string
    orderNumber: string
    narrowFulfilmentMethod: Types.NarrowFulfilmentMethodInputType
    outlet: {
      __typename: 'Outlet'
      id: string
      displayName: string
      restaurant: { __typename: 'Restaurant'; id: string; name: string }
      outletAddress: {
        __typename: 'Address'
        firstLine: string
        secondLine: string | null
        thirdLine: string | null
        postcode: string
      }
    }
  }
}

export const CheckoutSuccessDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckoutSuccessData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'order' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'narrowFulfilmentMethod' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outlet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'restaurant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outletAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstLine' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondLine' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thirdLine' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'postcode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckoutSuccessDataQuery,
  CheckoutSuccessDataQueryVariables
>
